export default __webpack_public_path__ + "f13d6a070aa12a8682e751d8d0e35c39.png";